/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../common";
import type { Staking, StakingInterface } from "../Staking";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract stkETHTest",
        name: "_stkETH",
        type: "address",
      },
      {
        internalType: "contract L1MessageContractTest",
        name: "_l1Messenger",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "InsufficientBalance",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "indexed_user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "block_time",
        type: "uint256",
      },
    ],
    name: "Stake",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "optimism",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "TransferredToOptimism",
    type: "event",
  },
  {
    inputs: [],
    name: "l1Messenger",
    outputs: [
      {
        internalType: "contract L1MessageContractTest",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "optimismAddress",
        type: "address",
      },
    ],
    name: "mintOptimism",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "stake",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "stkETH",
    outputs: [
      {
        internalType: "contract stkETHTest",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "optimismAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferToOptimism",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type StakingConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: StakingConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Staking__factory extends ContractFactory {
  constructor(...args: StakingConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    _stkETH: PromiseOrValue<string>,
    _l1Messenger: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<Staking> {
    return super.deploy(
      _stkETH,
      _l1Messenger,
      overrides || {}
    ) as Promise<Staking>;
  }
  override getDeployTransaction(
    _stkETH: PromiseOrValue<string>,
    _l1Messenger: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_stkETH, _l1Messenger, overrides || {});
  }
  override attach(address: string): Staking {
    return super.attach(address) as Staking;
  }
  override connect(signer: Signer): Staking__factory {
    return super.connect(signer) as Staking__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): StakingInterface {
    return new utils.Interface(_abi) as StakingInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Staking {
    return new Contract(address, _abi, signerOrProvider) as Staking;
  }
}
